import React, { useEffect, useState } from "react";
import AuthNavComponent from "app/pages/module/auth/AuthNav";
import Footer from "app/pages/module/Footer";
import { Button } from "sr/helpers";
import { FormattedMessage, useIntl } from "react-intl";
import { useGet } from "app/pages/company/Hooks/Api/useGet";
import { useNavigate, useParams } from "react-router-dom";
import { getWorkorder } from "sr/utils/api/company/workorder/getWorkorder";
import { getTask } from "sr/utils/api/company/customer/getTask";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { getContractor } from "sr/utils/api/company/workorder/getContractor";
import { getTaskManage } from "sr/utils/api/company/workorder/getTaskManage";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { toast } from "react-toastify";
import { updateWorkorder } from "sr/utils/api/company/workorder/updateWorkorder";
import { getManageTaskSubmit } from "sr/utils/api/company/workorder/getManageTaskSubmit";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import { TaskDetailsCard } from "./component/TaskDetailsCard";
import { DateFormat } from "sr/helpers/functions/DateFormat";
import { StringTimeFormat } from "sr/helpers/functions/StringTimeFormat";
import { useSelector } from "react-redux";
import { RootState } from "sr/redux/store";
import { getUserFullProfile } from "sr/utils/api/user/user";
import { STRIPE_ONBOARDING_STATUSES } from "sr/constants/common";
import { getFeeTransparency } from "sr/utils/api/fee/getFeeTransparency";
import { FeeBreakdownBox } from "app/pages/component/FeeBreakdownBox";
import moment from "moment";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import { applyWorkOrder } from "sr/utils/api/company/workorder/applyWorkOrder";

export const MyJobDetails = () => {
  const {
    getData: getWorkOrders,
    data: workorder,
    loader: loaderWorkOrder,
    pageination: pageination,
  }: any = useGet();
  const {
    data: checklistData,
    loader: checklistLoader,
    getData: getChecklists,
  } = useGet();
  const [loader, setLoader] = useState(false);
  const [workHours, setWorkHours] = useState(0);
  const [feeTransparency, setFeeTransparency] = useState<any>(null);
  const intl = useIntl();
  const notAvailable = intl.formatMessage({
    id: "COMMON.NOT_AVAILABLE",
  });
  const hoursLabel = intl.formatMessage({
    id: "COMMON.HOURS",
  });
  const feeBreakdownLabel = intl.formatMessage({
    id: "WORKORDER.DETAILS.FEE_BREAKDOWN",
  });
  const youReceiveLabel = intl.formatMessage({
    id: "WORKORDER.DETAILS.YOU_RECEIVE",
  });
  const params = useParams();
  const [workorderId, setWorkOrderId] = useState<any>();
  const [cleanerId, setCleanerId] = useState();
  const [userFullProfile, setUserFullProfile] = useState<any>({});
  const appSettingsData = useSelector((s: RootState) => s.appSettings.data);
  const {
    data: contractor,
    getData: getContractorDetails,
    loader: contractorLoader,
  } = useGet();
  const {
    data: managetasks,
    getData: getManageTaskList,
    loader: taskmanageLoader,
  } = useGet();
  const {
    data: submittask,
    getData: getTaskSubmitted,
    loader: trackloader,
  } = useGet();
  const navigate = useNavigate();
  const fetchManageTask = async () => {
    const queryParams = new URLSearchParams();
    if (workorderId) queryParams?.append("workorder_id", workorderId);
    await getManageTaskList(() => getTaskManage(queryParams));
    return true;
  };
  const fetchTaskTrack = async () => {
    const queryParams = new URLSearchParams();
    if (workorderId) queryParams?.append("workorder_id", workorderId);
    await getTaskSubmitted(() => getManageTaskSubmit(queryParams));

    return true;
  };
  useEffect(() => {
    if (workorderId) {
      fetchTaskTrack();
      fetchManageTask();
    }
  }, [workorderId]);

  useEffect(() => {
    const { user_id } = getUserDetails();
    setCleanerId(user_id);
    (async () => {
      const userFullProfileRes = await getUserFullProfile();

      setUserFullProfile(userFullProfileRes?.data);
    })();
  }, []);

  useEffect(() => {
    const FetchContractor = async (cleanerId) => {
      const useParams = new URLSearchParams();
      if (cleanerId) useParams?.append("cleaner_id", cleanerId);
      await getContractorDetails(() => getContractor(useParams));
    };
    if (cleanerId) {
      FetchContractor(cleanerId);
    }
  }, [cleanerId]);

  useEffect(() => {
    const { id } = params;
    setWorkOrderId(id);
  }, [params]);
  const stepperIndex = 2;
  const fetchWorkOrder = async (workorderId) => {
    const queryParams = new URLSearchParams();
    if (workorderId) queryParams.append("id", workorderId);
    await getWorkOrders(() => getWorkorder(queryParams));
  };
  useEffect(() => {
    if (workorderId) {
      fetchWorkOrder(workorderId);
    }
  }, [workorderId]);

  useEffect(() => {
    const tx = workorder?.payment_transaction_detail;
    if (tx) {
      setFeeTransparency(null);
      return;
    }
    const amount = Number(workorder?.pay_type_rate);
    if (!amount || Number.isNaN(amount) || amount <= 0) {
      setFeeTransparency(null);
      return;
    }
    (async () => {
      try {
        const res = await getFeeTransparency({
          jobType: "workorder",
          amount,
        });
        if (res?.success === true) {
          setFeeTransparency(res?.data || null);
        } else {
          setFeeTransparency(null);
        }
      } catch (e) {
        setFeeTransparency(null);
      }
    })();
  }, [workorder?.pay_type_rate, workorder?.payment_transaction_detail]);

  const feeData = workorder?.payment_transaction_detail || feeTransparency;
  const paymentStatus = workorder?.payment_transaction_detail?.status;
  const formatActualTime = (value) => {
    if (!value) return null;
    const dateObject = new Date(value);
    const hours = String(dateObject.getHours());
    const minutes = String(dateObject.getMinutes()).padStart(2, "0");
    return StringTimeFormat(`${hours}:${minutes}`);
  };
  const fetchChecklist = async (id) => {
    const queryParams = new URLSearchParams();
    if (id) queryParams.append("checklist_id", id);
    queryParams.append("status", "active");
    await getChecklists(() => getTask(queryParams));
  };
  useEffect(() => {
    if (workorder?.checklist_id?._id) {
      fetchChecklist(workorder?.checklist_id?._id);
    }
  }, [workorder?.checklist_id?._id]);
  const HandleTaskSubmit = async () => {
    setLoader(true);
    let camt = true;
    const mandatoryTasks = checklistData?.filter(
      (item) => item?.type === "Mandatory",
    );
    if (mandatoryTasks?.length > 0) {
      for (let i = 0; i < mandatoryTasks?.length; i++) {
        const result = managetasks?.some(
          (item) => item?.task_id?._id === mandatoryTasks[i]?.id,
        );
        if (result === true) {
        } else {
          toast.error("You have not completed all mandatory tasks");
          camt = false;
          setLoader(false);
          break;
        }
      }
    }

    // Check for mandatory media upload requirement
    if (camt === true && checklistData?.length > 0) {
      for (let i = 0; i < checklistData?.length; i++) {
        const task = checklistData[i];

        // Check if this task requires mandatory media
        if (task?.is_media_upload_required === true) {
          const completedTask = managetasks?.find(
            (item) => item?.task_id?._id === task?.id,
          );

          // If task is completed, check if it has media attached
          if (completedTask) {
            const hasImages = completedTask?.images && completedTask?.images?.length > 0;
            const hasVideos = completedTask?.videos && completedTask?.videos?.length > 0;

            if (!hasImages && !hasVideos) {
              toast.error(`Please attach a photo or video to complete ${task?.name}.`);
              camt = false;
              setLoader(false);
              break;
            }
          }
        }
      }
    }

    if (camt === true) {
      navigate(`/review-work-order/${workorderId}`);
      setLoader(false);
    }
  };
  const HandleStartWorkOrder = async () => {
    setLoader(true);
    const payload = {
      id: workorder?.id,
      workorder_status: "in progress",
    };
    const res = await updateWorkorder(payload);
    if (res?.success === true) {
      await fetchWorkOrder(workorderId);
      toast.success("Your Work Order is Started");
    }
    setLoader(false);
  };

  const handleAccept = async () => {
    setLoader(true);
    const payload = {
      id: workorderId,
      workorder_status: "accepted",
    };
    try {
      const res = await updateWorkorder(payload);
      if (res?.success === true) {
        fetchWorkOrder(workorderId);
        toast.success("Job accepted");
      }
      await applyWorkOrder({
        workorder_id: workorderId,
        status: "accept",
        cleaner_id: cleanerId,
      }, true);
      setLoader(false);
    } catch (e) {
      setLoader(false);
      HandleApiError(e);
    }
  };

  const handleReject = async () => {
    setLoader(true);
    const payload = {
      id: workorderId,
      workorder_status: "rejected",
    };
    try {
      const res = await updateWorkorder(payload);
      if (res?.success === true) {
        fetchWorkOrder(workorderId);
        toast.success("Job rejected");
      }
      setLoader(false);
    } catch (e) {
      setLoader(false);
      HandleApiError(e);
    }
  };

  return (
    <>
      <AuthNavComponent isLoggedin={true}></AuthNavComponent>
      <main>
        {loader && <LoaderFullScreen />}
        <ContentWithSpinner
          loader={
            loaderWorkOrder === false
              ? workorder?.checklist_id?._id
                ? checklistLoader
                : loaderWorkOrder
              : loaderWorkOrder
          }
          height="h-screen"
        >
          <div className="py-3 lg:container mx-auto lg:max-w-6xl lg:mt-10 mt-10 px-4 lg:px-0">
            <div className="mb-5">
              <h1 className="text-2xl ">
                <FormattedMessage
                  id="MYJOB.MANAGE_JOB.TITLE"
                  defaultMessage="Mark As Completed"
                />
              </h1>
            </div>
            <div className="bg-white rounded-[20px] shadow-sm shadow-slate-300">
              <div className="flex w-full flex-wrap lg:px-20 lg:py-10 px-5 py-5">
                <div className="lg:w-1/3 w-1/2 pb-5">
                  <p className="font-bold">
                    <FormattedMessage id="WORKORDER.TABLE.COL.WORKORDER.TITLE" />
                    :
                  </p>
                  <p>{workorder?.title || notAvailable}</p>
                </div>
                <div className="lg:w-1/3 w-1/2 pb-5">
                  <p className="font-bold">
                    <FormattedMessage id="WORKORDER.TABLE.COL.CUSTOMER.NAME.TITLE" />
                    :
                  </p>
                  <p>{workorder?.customer_id?.name || notAvailable}</p>
                </div>
                <div className="lg:w-1/3 w-1/2 pb-5">
                  <p className="font-bold">
                    <FormattedMessage id="WORKORDER.DETAILS.LOCATION_NAME" />:
                  </p>
                  <p>{workorder?.customer_location_id?.name || notAvailable}</p>
                </div>
                <div className="lg:w-1/3 w-1/2 pb-5">
                  <p className="font-bold">
                    <FormattedMessage id="WORKORDER.DETAILS.ADDRESS" />:
                  </p>
                  <p>
                    {workorder?.customer_location_id?.address?.address_line_1}{" "}
                    {workorder?.customer_location_id?.address?.address_line_2}{" "}
                    {workorder?.customer_location_id?.address?.city ||
                      notAvailable}
                  </p>
                </div>
                <div className="lg:w-1/3 w-1/2 pb-5">
                  <p className="font-bold">
                    <FormattedMessage id="WORKORDER.TABLE.COL.NAME.SCHEDULE.DATE" />
                    :
                  </p>
                  <p>{DateFormat(workorder?.one_time_date) || notAvailable}</p>
                </div>
                <div className="lg:w-1/3 w-1/2 pb-5">
                  <p className="font-bold">
                    <FormattedMessage id="PENDING.JOBS.TEXT.TITLE.ENTRYTIME" />:
                  </p>
                  <p>{StringTimeFormat(workorder?.entry_time)}</p>
                </div>
                <div className="lg:w-1/3 w-1/2 pb-5">
                  <p className="font-bold">
                    <FormattedMessage id="PENDING.JOBS.TEXT.TITLE.EXITTIME" />:
                  </p>
                  <p>{StringTimeFormat(workorder?.exit_time)}</p>
                </div>
                {workorder?.workorder_status === "completed" && (
                  <>
                    <div className="lg:w-1/3 w-1/2 pb-5">
                      <p className="font-bold">
                        <FormattedMessage id="CLEANER.JOBS.FILTER.JOBTYPE" />:
                      </p>
                      <p>{workorder?.job_type || notAvailable}</p>
                    </div>
                    <div className="lg:w-1/3 w-1/2 pb-5">
                      <p className="font-bold">
                        <FormattedMessage id="PENDING.JOBS.TEXT.TYPE" />:
                      </p>
                      <p>{workorder?.type || notAvailable}</p>
                    </div>
                    <div className="lg:w-1/3 w-1/2 pb-5">
                      <p className="font-bold">
                        <FormattedMessage id="WORKORDER.DETAILS.ACTUAL_ENTRY_TIME" />
                        :
                      </p>
                      <p>
                        {workorder?.work_start_date_time_utc
                          ? moment(workorder?.work_start_date_time_utc).format(
                              "hh:mm A",
                            )
                          : notAvailable}
                      </p>
                    </div>
                    <div className="lg:w-1/3 w-1/2 pb-5">
                      <p className="font-bold">
                        <FormattedMessage id="WORKORDER.DETAILS.ACTUAL_EXIT_TIME" />
                        :
                      </p>
                      <p>
                        {workorder?.work_end_date_time_utc
                          ? moment(workorder?.work_end_date_time_utc).format(
                              "hh:mm A",
                            )
                          : notAvailable}
                      </p>
                    </div>
                    <div className="lg:w-1/3 w-1/2 pb-5">
                      <p className="font-bold">
                        <FormattedMessage id="WORKORDER.TABLE.COL.NAME.COMPLETION.DATE" />
                        :
                      </p>
                      <p>
                        {workorder?.work_end_date_time_utc
                          ? moment(workorder?.work_end_date_time_utc).format(
                              "MM/DD/YYYY",
                            )
                          : notAvailable}
                      </p>
                    </div>
                    <div className="lg:w-1/3 w-1/2 pb-5">
                      <p className="font-bold">
                        <FormattedMessage id="WORKORDER.DETAILS.TIME_FOR_COMPLETION" />
                        :
                      </p>
                      <p>
                        {workorder?.time_for_work_completion
                          ? `${workorder?.time_for_work_completion} ${hoursLabel}`
                          : notAvailable}
                      </p>
                    </div>
                    <div className="lg:w-full pb-5">
                      <p className="font-bold">
                        <FormattedMessage id="WORKORDER.DETAILS.WORK_DESCRIPTION" />
                        :
                      </p>
                      <p>{workorder?.description || notAvailable}</p>
                    </div>
                  </>
                )}
              </div>
              <div className="lg:px-20 px-5 pb-10">
                {feeData ? (
                  <div className="max-w-[320px]">
                    <div className="flex items-start justify-between gap-3">
                      <div>
                        <div className="text-sm font-medium text-neutral-900">
                          {feeBreakdownLabel}
                        </div>
                      </div>
                    </div>
                    <FeeBreakdownBox
                      className="mt-3"
                      rows={[
                        {
                          label: intl.formatMessage({
                            id: "COMMON.SERVICE_AMOUNT",
                          }),
                          value: Number(feeData?.amount || 0),
                        },
                        {
                          label: intl.formatMessage({
                            id: "COMMON.SERVICE_FEE",
                          }),
                          value: Number(feeData?.job_seeker_fee_amount || 0),
                        },
                      ]}
                      totalLabel={youReceiveLabel}
                      totalValue={Number(
                        feeData?.job_seeker_received_amount || 0,
                      )}
                      status={paymentStatus}
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            {workorder?.workorder_status === "scheduled" &&
            workorder?.is_contract_workorder ? (
              <div className="bg-white rounded-[20px] shadow-sm shadow-slate-300 my-3">
                <div className="flex justify-center py-10 gap-5 ">
                  <button
                    onClick={() => handleAccept()}
                    className="rounded-lg bg-[#ff39b3] font-bold px-5 py-2 text-white cursor-pointer hover:bg-navy"
                  >
                    Accept
                  </button>
                  <button
                    onClick={() => handleReject()}
                    className="rounded-lg font-bold text-white px-5 py-2 bg-red-500 border-2 cursor-pointer hover:text-white hover:border-white"
                  >
                    Reject
                  </button>
                </div>
              </div>
            ) : workorder?.workorder_status === "rejected" &&
              workorder?.is_contract_workorder ? (
              <div className="bg-white rounded-[20px] shadow-sm shadow-slate-300 my-3">
                <div className="text-center py-10 ">
                  {intl.formatMessage({
                    id: "COMMON.WORK_ORDER_DECLINED",
                  })}
                </div>
              </div>
            ) : (
              <div className="bg-white rounded-[20px] shadow-sm shadow-slate-300 my-3">
                {workorder?.workorder_status === "scheduled" ||
                workorder?.workorder_status === "accepted" ? (
                  <div className="flex justify-center py-10">
                    <Button
                      disabled={
                        appSettingsData &&
                        appSettingsData?.isPlatformPaymentActive != undefined &&
                        appSettingsData?.isPlatformPaymentActive === true &&
                        !userFullProfile?.id
                      }
                      onClick={() => {
                        if (
                          appSettingsData &&
                          appSettingsData?.isPlatformPaymentActive !=
                            undefined &&
                          appSettingsData?.isPlatformPaymentActive === true
                        ) {
                          if (
                            !userFullProfile?.id ||
                            !userFullProfile?.stripe_customer_model ||
                            !userFullProfile?.stripe_customer_model?.id ||
                            !userFullProfile?.stripe_customer_model
                              ?.stripe_connect_ac_id ||
                            !userFullProfile?.stripe_customer_model
                              ?.stripe_onboarding_status ||
                            (userFullProfile?.stripe_customer_model
                              ?.stripe_onboarding_status !== undefined &&
                              userFullProfile?.stripe_customer_model
                                ?.stripe_onboarding_status !==
                                STRIPE_ONBOARDING_STATUSES.SUCCESS)
                          ) {
                            toast.error(
                              intl.formatMessage({
                                id: "API.ERROR.PAYMENTMETHOD.NOT.FOUND",
                                defaultMessage:
                                  "Please set up your payment method first",
                              }),
                            );
                            return;
                          }
                        }
                        HandleStartWorkOrder();
                      }}
                      text={intl.formatMessage({
                        id: "COMMON.START_WORK_ORDER",
                      })}
                      className={
                        "bg-[#ff39b3] font-bold text-white capitalize "
                      }
                      hoverbg={"bg-[#ff39b3] font-bold "}
                    ></Button>
                  </div>
                ) : submittask?.length > 0 &&
                  submittask[0]?.status === "rejected" ? (
                  <div className="text-center py-10 ">
                    {intl.formatMessage({
                      id: "COMMON.WORK_ORDER_REJECTED",
                    })}
                  </div>
                ) : submittask?.length > 0 &&
                  submittask[0]?.contractor_status === "any" ? (
                  submittask?.length > 0 &&
                  submittask[0]?.supervisor_status === "completed" ? (
                    <div className="text-center py-10 ">
                      {intl.formatMessage(
                        {
                          id: "COMMON.WORK_ORDER_COMPLETED_APPROVED_HOURS",
                        },
                        { hours: submittask?.[0]?.approve_time },
                      )}
                    </div>
                  ) : (
                    <div className="text-center py-10 ">
                      {intl.formatMessage({
                        id: "COMMON.TASK_SUBMITTED_SUCCESSFULLY",
                      })}
                    </div>
                  )
                ) : (
                  <>
                    {checklistData?.map((item, index) => (
                      <TaskDetailsCard
                        item={item}
                        managetasks={managetasks}
                        workorderId={workorderId}
                        contractor={contractor}
                        fetchManageTask={fetchManageTask}
                      />
                    ))}

                    <div className="flex justify-center my-3">
                      {(workorder?.workorder_status === "scheduled" ||
                        workorder?.workorder_status === "in progress" ||
                        workorder?.workorder_status === "accepted") && (
                        <Button
                          onClick={() => HandleTaskSubmit()}
                          text={
                            <FormattedMessage
                              id="MYJOB.NEXT.BUTTON"
                              defaultMessage="Next"
                            />
                          }
                          className={
                            "bg-[#ff39b3] font-bold text-white capitalize "
                          }
                          hoverbg={"bg-[#ff39b3] font-bold "}
                        ></Button>
                      )}
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </ContentWithSpinner>
      </main>
      <Footer />
    </>
  );
};
